import actionCreatorFactory from 'typescript-fsa';

import { SharingPartner } from '../../core/api/sharing/sharing.types';
import reduxConfig from '../config';
import { LoadsDeliveriesRationContentForm } from '../../routes/Manage/DataTools/DataToolsPage/DataToolsSpecificPage/DataToolsSpecificPageContent/LoadDeliveriesDataTools/LoadDeliveriesContent/LoadsDeliveriesRationContent/LoadsDeliveriesRationContent';
import { SettingsType } from '../entities/settings/settings.types';

const actionCreator = actionCreatorFactory(reduxConfig.appName + '/selected');

export const setSelectedIngredient = actionCreator<string | undefined>('SET_SELECTED_INGREDIENT');
export const setSelectedPremix = actionCreator<string | null>('SET_SELECTED_PREMIX');
export const setSelectedRecipe = actionCreator<string | null>('SET_SELECTED_RECIPE');
export const setSelectedGroup = actionCreator<string | null>('SET_SELECTED_GROUP');
export const setSelectedFeeding = actionCreator<string | null>('SET_SELECTED_FEEDING');
export const setSelectedFeedingPeriod = actionCreator<string | null>('SET_SELECTED_FEEDING_PERIOD');
export const setSelectedMixer = actionCreator<string | null>('SET_SELECTED_MIXER');
export const setSelectedReport = actionCreator<number | null>('SET_SELECTED_REPORT');
export const setSelectedReportFormat = actionCreator<number>('SET_SELECTED_REPORT_FORMAT');
export const resetSelected = actionCreator('RESET_SELECTED');
export const addSelectedPartner = actionCreator<SharingPartner>('ADD_SELECTED_PARTNER');
export const setCurrentFarm = actionCreator<string>('SET_CURRENT_FARM');
export const setFocusedGroupId = actionCreator<number>('SET_FOCUSED_GROUP_ID');
export const setFocusedGroupField = actionCreator<number>('SET_FOCUSED_GROUP_FIELD');
export const setFocusedRecipeId = actionCreator<number>('SET_FOCUSED_RECIPE_ID');
export const setFocusedPremixId = actionCreator<number>('SET_FOCUSED_PREMIX_ID');
export const setFocusedMatterId = actionCreator<number>('SET_FOCUSED_MATTER_ID');
export const setFocusedMatterField = actionCreator<number>('SET_FOCUSED_MATTER_FIELD');
export const setSelectedLoadDeliveryRation = actionCreator<LoadsDeliveriesRationContentForm | undefined>(
  'SET_SELECTED_LOAD_DELIVERY_RATION',
);
export const setSelectedLotId = actionCreator<string | undefined>('SET_SELECTED_LOT_ID');
export const setSelectedLoadMixersPremix = actionCreator<string | undefined>('SET_SELECTED_LOAD_MIXERS_PREMIX');
export const setSelectedSettingsPanel = actionCreator<SettingsType>('SET_SELECTED_SETTINGS_PANEL');
export const setSelectedCompany = actionCreator<string | null>('SET_SELECTED_COMPANY');
export const setSelectedOrderId = actionCreator<string | null>('SET_SELECTED_ORDER_ID');
export const setSelectedWeighbridgeTicket = actionCreator<string | null>('SET_SELECTED_WEIGHBRIDGE_TICKET');
export const setSelectedBunkReaderPen = actionCreator<string | null>('SET_SELECTED_BUNK_READER_PEN');
